module.exports = __webpack_public_path__ + "img/52002770_L.cc39fe35.png";